import { useSelector } from 'react-redux'

export const useGetSettings = () => {
  const settings = useSelector((store: any) => store.settings) as Record<string, string>
  const status = useSelector((store: any) => store.settings?.status)
  const loadingSettings = status < 2

  const getSettings = (key: string): string | null => {
    return settings?.[key] ?? null
  }

  const checkSettings = (key: string): boolean => {
    return settings?.[key] === '1'
  }

  return { getSettings, checkSettings, loadingSettings }
}
